import React, { useState, useEffect } from 'react';
import { Card, DatePicker, Table, Typography, Spin, message, Row, Col, Divider, Typography as AntTypography, Select, Space, Carousel, Badge, List, Empty } from 'antd';
import axios from 'axios';
import dayjs from 'dayjs';
import RMDeviation from './rm-deviation';
import appSettings from 'apps/services/config';
import { CalendarOutlined } from '@ant-design/icons';
import moment, { Moment } from 'moment';
import { Pie } from '@ant-design/plots';
import { MainDashboardService } from '@gtpl/shared-services/analytics';
import { SelectValue } from 'antd/lib/select';
import { GradeServices, SuppliersService } from '@gtpl/shared-services/masters';

const { RangePicker } = DatePicker;
const { Title } = Typography;

const ProcurementDashboard = () => {
const defaultMockData = {
  rawMaterials: { qty: '-', value: '-' },
  supplierData: [],
};
  const [dateRange, setDateRange] = useState<[Moment, Moment] | null>([
    moment().subtract(2, 'days'),
    moment()
  ]);
  const [loading, setLoading] = useState(false);
  const [dashboardData, setDashboardData] = useState(defaultMockData);
  const [ supplierData, setSupplierData ] = useState([]);
  const [ arrivalData, setArrivalData ] = useState([]);
  const [antibioticData, setAntibioticData] = useState([]);
  const [ supplierFilter, setSupplierFilter ] = useState<any| null>(null)
  const [ countFilter, setCountFilter ] = useState<any | null>(null)
  const [ farmersData, setFarmersData ] = useState([])
  const supplierService = new SuppliersService()
  const gradeService = new GradeServices()
  const [ gardeData, setGradeDate ] = useState([])

  const getAllFarmers=()=>{
    supplierService.getAllSuppliersNames().then((res)=>{
      if(res.status){
        setFarmersData(res.data)
      }else{
        setFarmersData([])
      }
    }).catch((err)=>{
      console.error('API Error:', err);
      message.error('Failed to fetch data');
      setFarmersData([])
    })
  }

  const getAllGrades=()=>{
    gradeService.getAllGrades().then((res)=>{
      if(res.status){
        setGradeDate(res.data)
      }else{
        setGradeDate([])
      }
    }).catch((err)=>{
      console.error('API Error:', err);
      message.error('Failed to fetch data');
      setGradeDate([])
    })
  }

  const CARD_HEIGHT = '460px';
  const TABLE_HEIGHT = '360px';
  const TABLE_SCROLL_HEIGHT = 'calc(360px - 15px)';

  const service = new MainDashboardService()

  const fetchData = async (fromDate, toDate, supplierId = supplierFilter, count = countFilter) => {
    setLoading(true);
    try {
      const requestBody: any = { fromDate, toDate };
  
      if (supplierId !== null && supplierId !== undefined) {
        requestBody.supplierId = supplierId;
      }
  
      if (count !== null && count !== undefined) {
        requestBody.gradeMinCount = count.gradeMinCount;
        requestBody.gradeMaxCount = count.gradeMaxCount;
      }
  
      const [rawMaterialRes, supplierRes] = await Promise.all([
        axios.post(`${appSettings.anlytics_url}/mainDashboard/getRawMaterialInward`, { fromDate, toDate }),
        axios.post(`${appSettings.anlytics_url}/mainDashboard/getSupplierValueWiseDate`, requestBody)
      ]);
  
      if (
        rawMaterialRes.data?.status &&
        supplierRes.data?.status &&
        rawMaterialRes.data.data?.length > 0 &&
        supplierRes.data.data?.length > 0
      ) {
        setDashboardData({
          rawMaterials: {
            qty: rawMaterialRes.data.data[0]?.qty,
            value: rawMaterialRes.data.data[0]?.value
          },
          supplierData: supplierRes.data.data
            .filter(item => item.supplier_name || item.code)
            .map((item, index) => ({
              key: index,
              supplier: `${item.supplier_name || 'Unknown Supplier'} (${item.code || 'No Code'})`,
              count: item.count || 0,
              qty: item.qty,
              value: item.value,
              supplierId: item.supplier_id,
              broker: item.broker
            }))
        });
      } else {
        setDashboardData({
          rawMaterials: { qty: '-', value: '-' },
          supplierData: []
        });
      }
    } catch (error) {
      console.error('API Error:', error);
      message.error('Failed to fetch data');
      setDashboardData({
        rawMaterials: { qty: '-', value: '-' },
        supplierData: []
      });
    } finally {
      setLoading(false);
    }
  };
  

  const getSupplierWiseProcurement = async () => {
    setLoading(true);
    try {
      service.getSupllierTypeWiseData().then(response =>{
      
      if (response.status) {
        setSupplierData(response.data);
        setLoading(false)
      }
      })
    } catch (error) {
      console.error('API Error:', error);
      message.error('Failed to fetch data');
      setLoading(false)
    } finally {
      setLoading(false);
    }
    
  };

  const getTodayArrivalQty=()=>{
    setLoading(true)
    service.getTodayArrivalQty().then((res)=>{
      if(res.status){
        setArrivalData(res.data)
        setLoading(false)
      }else{
        setLoading(false)
        setArrivalData([])
      }
    }).catch((err)=>{
      // console.error('API Error:', err);
      message.error('Failed to fetch data');
      setLoading(false)
    })
  }

  const getAntibioticTestResult=()=>{
    setLoading(true)
    service.getAntibioticTestResult().then((res)=>{
      if(res.status){
        setAntibioticData(res.data)
        setLoading(false)
      }else{
        setLoading(false)
        setAntibioticData([])
      }
    }).catch((err)=>{
      console.error('API Error:', err);
      message.error('Failed to fetch data');
      setLoading(false)
    })
  }

  const processData = (data) => {
    const typeMap = new Map();
    
    data.forEach((item) => {
      const total = typeMap.get(item.type) || 0;
      typeMap.set(item.type, total + item.yAxisValue);
    });
  
    return Array.from(typeMap).map(([type, value]) => ({
      type,
      value
    }));
  };

  const handleDateChange = (dates, dateStrings) => {
    setDateRange(dates);
    if (dateStrings[0] && dateStrings[1]) {
      fetchData(dateStrings[0], dateStrings[1]);
    }
  };

  useEffect(() => {
    const defaultFromDate = dayjs().subtract(2, 'day').format('YYYY-MM-DD');
    const defaultToDate = dayjs().format('YYYY-MM-DD');
    fetchData(defaultFromDate, defaultToDate);
    getSupplierWiseProcurement()
    getTodayArrivalQty()
    getAntibioticTestResult()
    getAllFarmers()
    getAllGrades()
  }, []);


  const colors = {
    primary: '#2D3A4B',
    secondary: '#4A90E2',
    accent: '#FF6B6B',
    background: '#F8F9FA',
    textSecondary: '#6C757D',
    success: '#28A745',
    warning: '#FFC107',
    headerBg: 'powderblue',
    headerText: 'black',
    cardHover: '#F8F9FA'
  };

  const cardStyles = {
    main: {
        borderRadius: '12px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
        transition: 'all 0.3s ease',
        border: '1px solid #e8e8e8',
        height: CARD_HEIGHT
    },
    header: {
        background: colors.headerBg,
        color: colors.headerText,
        borderRadius: '12px 12px 0 0',
        padding: '6px',
        fontSize: '16px',
        fontWeight: 600
    },
    metric: {
        fontSize: '24px',
        fontWeight: 600,
        color: colors.primary
    },
    metricLabel: {
        fontSize: '14px',
        color: colors.textSecondary
    }
  };

  const supplierColumns: any = (colors) => [
    {
      title: 'Supplier',
      dataIndex: 'supplier',
      key: 'supplier',
      render: (text) => <AntTypography.Text strong>{text}</AntTypography.Text>,
      fixed: 'left',
      width: 200
    },
    {
      title: 'Count',
      dataIndex: 'count',
      key: 'count',
      align: 'right' as const,
      width: 100,
      render: (text) => (
        <AntTypography.Text style={{ color: colors.success }}>
          {parseFloat(text).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
        </AntTypography.Text>
      )
    },
    {
      title: 'Quantity',
      dataIndex: 'qty',
      key: 'qty',
      align: 'right' as const,
      width: 100,
      render: (text) => (
        <AntTypography.Text style={{ color: colors.primary }}>
          {text != null
            ? parseFloat(text).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            : '0.00'}
        </AntTypography.Text>
      )
    },
    {
      title: 'Value',
      dataIndex: 'value',
      key: 'value',
      align: 'right' as const,
      width: 100,
      render: (text) => (
        <AntTypography.Text strong style={{ color: colors.secondary }}>
          {text != null
            ? parseFloat(text).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            : '0.00'}
        </AntTypography.Text>
      )
    }
  ];

  const config = {
    appendPadding: 10,
    data: processData(supplierData),
    angleField: 'value',
    colorField: 'type',
    radius: 0.8,
    label: {
      type: 'outer',
      content: '{name} {percentage}',
    },
    interactions: [
      { type: 'pie-legend-active' },
      { type: 'element-active' }
    ],
    tooltip: {
      fields: ['type', 'value'],
      formatter: (datum) => ({
        name: datum.type,
        value: datum.value.toLocaleString()
      })
    }
  };


  const handleSupplierChange = (value: number | undefined) => {
    const newValue = value ?? null;
    setSupplierFilter(newValue);
  
    if (dateRange?.[0] && dateRange?.[1]) {
      fetchData(
        dateRange[0].format('YYYY-MM-DD'),
        dateRange[1].format('YYYY-MM-DD'),
        newValue,
        countFilter
      );
    }
  };
  
  
  const handleCountChange = (selected) => {
    if (!selected) {
      setCountFilter(null);
      if (dateRange?.[0] && dateRange?.[1]) {
        fetchData(
          dateRange[0].format('YYYY-MM-DD'),
          dateRange[1].format('YYYY-MM-DD'),
          supplierFilter,
          { gradeMinCount: null, gradeMaxCount: null } 
        );
      }
      return;
    }
  
    const selectedGrade = gardeData.find(g => g.gradeName === selected.value);
    if (!selectedGrade) return;
  
    const { gradeMinCount, gradeMaxCount } = selectedGrade;
  
    const range = {
      gradeMinCount: Number(gradeMinCount),
      gradeMaxCount: Number(gradeMaxCount)
    };
  
    setCountFilter(range);
  
    if (dateRange?.[0] && dateRange?.[1]) {
      fetchData(
        dateRange[0].format('YYYY-MM-DD'),
        dateRange[1].format('YYYY-MM-DD'),
        supplierFilter,
        range
      );
    }
  };
  

  return (
    <div style={{ padding: '10px 24px 24px 24px', background: colors.background }}>
      <Row justify="space-between" align="middle" style={{ marginBottom: 24 }}>
        <Col>
          <Title level={3} style={{ margin: 0, color: colors.primary }}>
            Procurement Dashboard
          </Title>
          {/* <AntTypography.Text type="secondary" style={{ color: colors.textSecondary }}>
            Real-time procurement insights and analytics
          </AntTypography.Text> */}
        </Col>
      </Row>

      <Row  gutter={[24, 24]} style={{ marginTop: 12 }}>
        <Col xs={24} md={18}>
          <Card
            title="Supplier Performance"
            bordered={false}
            style={{ ...cardStyles.main }}
            bodyStyle={{ padding: 0, height: '100%', display: 'flex', flexDirection: 'column' }}
            headStyle={{ 
              background: 'powderblue', 
              color: 'black', 
              fontSize: 16, 
              fontWeight: 600, 
              borderRadius: '12px 12px 0 0',
              padding: '3px 12px',
              lineHeight: '0.2px',
              borderBottom: 0
            }}
            extra={
              <Space direction={window.innerWidth < 768 ? 'vertical': 'horizontal'}>
                <Select
                  placeholder="Select Supplier"
                  style={{ width: '100%', maxWidth: 200 }}
                  allowClear
                  onChange={handleSupplierChange}
                  showSearch
                  filterOption={(input, option) =>
                    option?.children?.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {farmersData.map((supplier) => (
                    <Select.Option key={supplier.supplierId} value={supplier.supplierId}>
                      {`${supplier.supplierName} (${supplier.supplierCode})`}
                    </Select.Option>
                  ))}
                </Select>
                <Select
                  placeholder="Select Count"
                  style={{ width: '100%', maxWidth: 160 }}
                  onChange={handleCountChange}
                  labelInValue
                  showSearch
                  filterOption={(input, option) =>
                    option?.children?.toLowerCase().includes(input.toLowerCase())
                  }
                  allowClear
                >
                  {gardeData.map((grade) => (
                    <Select.Option key={grade.gradeId} value={grade.gradeName}>
                      {grade.gradeName}
                    </Select.Option>
                  ))}
                </Select>

                <RangePicker
                  onChange={handleDateChange}
                  value={dateRange}
                  style={{ width: '100%', maxWidth: 230 }}
                  allowClear={false}
                  suffixIcon={<CalendarOutlined style={{ color: colors.textSecondary }} />}
                />
              </Space>
            }
          >
            <Spin spinning={loading}>
              <div style={{ position: 'relative', height: '100%' }}>
                {dashboardData.supplierData.length > 0 ? (
                  <Table
                  dataSource={dashboardData.supplierData}
                  columns={supplierColumns(colors)}
                  pagination={false}
                  scroll={{ x: 'max-content', y: TABLE_SCROLL_HEIGHT }}
                  size="middle"
                  bordered
                  rowKey="key"
                  style={{ 
                    width: '100%',
                    height: TABLE_HEIGHT,
                    marginBottom: '15px'
                  }}
                />
                ):(
                  <Empty description="No records found" />
                )}
              </div>
            </Spin>
          </Card>
        </Col>



        <Col xs={24} md={6}>
          <div style={{ margin: '16px 0' }}>
            <Card 
              bordered={false} 
              style={{ 
                ...cardStyles.main,
                width: '100%',
                maxWidth: 300,
                height: 90,
                // display: 'flex',
                // alignItems: 'center',
                // justifyContent: 'center',
                margin: '0 auto'
              }} 
              bodyStyle={{ padding: '12px' }}
            >
              <Row gutter={16}>
                <Col span={12}>
                  <div style={{ textAlign: 'center' }}>
                    <AntTypography.Text style={{ ...cardStyles.metricLabel, fontSize: 12 }}>
                      Total Qty
                    </AntTypography.Text>
                    <div style={{ ...cardStyles.metric, fontSize: 18, color: colors.success }}>
                      {dashboardData.rawMaterials.qty}
                    </div>
                  </div>
                </Col>
                <Col span={12}>
                  <div style={{ textAlign: 'center' }}>
                    <AntTypography.Text style={{ ...cardStyles.metricLabel, fontSize: 12 }}>
                      Total Value
                    </AntTypography.Text>
                    <div style={{ ...cardStyles.metric, fontSize: 18, color: colors.secondary }}>
                      {dashboardData?.rawMaterials?.value}
                    </div>
                  </div>
                </Col>
              </Row>
            </Card>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', margin: '16px 0', alignItems: 'center' }}>
          <Card
            title= {`Arrival's (Last 3 days): ${arrivalData.length}`}
            bordered={false}
            style={{
              width: '100%',
              maxWidth: 320,
              height: 160,
              border: '1px solid #e8e8e8',
              borderRadius: 8,
              textAlign: 'center',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
            }}
            headStyle={{
              background: 'powderblue',
              padding: '3px 6px',
              lineHeight: '0.2px',
              fontSize: 14,
              fontWeight: 600,
              borderRadius: '8px 8px 0 0',
              borderBottom: 0
            }}
            bodyStyle={{ padding: 0 }}
          >
            <Carousel
              autoplay
              autoplaySpeed={2000}
              // arrows
              infinite={true}
              dots={false}
              // dotPosition="top"
              style={{ height: '100%', width: '100%' }}
            >
              {arrivalData.map((item, index) => (
                <div key={index} style={{padding: '0 8px', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                  <div
                    style={{
                      width: '100%',
                      padding: 8,
                      borderRadius: 6,
                    }}
                  >
                    <div style={{ fontSize: 16 }}>Count: {item.count}</div>
                    <div style={{ fontSize: 20, fontWeight: 'bold' }}>
                      Quantity: {item.qty.toLocaleString()} Kg
                    </div>
                  </div>
                </div>
              ))}
            </Carousel>
          </Card>

          <Card
            title={`Antibiotics Failed: ${antibioticData.length} Suppliers`}
            bordered={false}
            style={{
              width: '100%',
              maxWidth: 320,
              height: 160,
              border: '1px solid #e8e8e8',
              borderRadius: 8,
              textAlign: 'center',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
            }}
            headStyle={{
              background: 'powderblue',
              padding: '3px 6px',
              lineHeight: '0.2px',
              fontSize: 14,
              fontWeight: 600,
              borderRadius: '8px 8px 0 0',
              borderBottom: 0
            }}
            bodyStyle={{ padding: 0 }}
          >
            <Carousel
              autoplay
              autoplaySpeed={2000}
              // arrows
              infinite={true}
              // dotPosition="top"
              dots={false}
              style={{ height: '100%', width: '100%' }}
            >
              {antibioticData.map((item, index) => (
                <div key={index} style={{padding: '0 8px', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                  <div
                    style={{
                      width: '100%',
                      padding: 8,
                      borderRadius: 6,
                    }}
                  >
                    <div style={{ fontSize: 16 }}>Code: {item.code}</div>
                    <div style={{ fontSize: 16 }}>Qty: {
                      item.quantities.includes(',') 
                        ? item.quantities.split(',').map(qty => qty.trim()).join(' | ')
                        : item.quantities
                    }</div>
                    <div style={{ fontSize: 20, fontWeight: 'bold', color: 'red' }}>
                      {item.name}
                    </div>
                  </div>
                </div>
              ))}
            </Carousel>
          </Card>
          </div>
        </Col>
      </Row>
  
      <Row gutter={[24, 24]} style={{marginTop: 24}}>
        <Col xs={24} md={12}>
          <div style={{ height: CARD_HEIGHT }}>
            <RMDeviation cardHeight={CARD_HEIGHT} tableHeight={TABLE_SCROLL_HEIGHT} />
          </div>
        </Col>
        <Col xs={24} md={12}>
          <Card 
            title='Supplier Procurement Distribution'
            bordered={false}
            bodyStyle={{ padding: 0 }}
            style={{
              height: '100%',
              margin: 0,
              borderRadius: '8px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
            }}
            headStyle={{
              background: 'powderblue',
              color: 'black',
              fontSize: 16,
              fontWeight: 600,
              borderRadius: '12px 12px 0 0',
              borderBottom: 0,
              padding: '3px 12px',
              lineHeight: '0.2px',
            }}
            >
            <Spin spinning={loading}>
              {supplierData.length > 0 ? (
                <Pie {...config}/>
              ):( 
                <Empty description="No records found" />
              )}
            </Spin>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default ProcurementDashboard;